const CarIcon = () => {
    return (
        <svg
            width='20'
            height='24'
            viewBox='0 0 20 24'
            fill='none'
            xmlns='http://www.w3.org/2000/svg'
        >
            <path
                opacity='0.2'
                d='M17.5 17.25V19.5C17.5 19.6989 17.4342 19.8897 17.3169 20.0303C17.1997 20.171 17.0408 20.25 16.875 20.25H15C14.8342 20.25 14.6753 20.171 14.5581 20.0303C14.4408 19.8897 14.375 19.6989 14.375 19.5V17.25H17.5Z'
                fill='#827CA8'
            />
            <path
                opacity='0.2'
                d='M5.625 17.25V19.5C5.625 19.6989 5.55915 19.8897 5.44194 20.0303C5.32473 20.171 5.16576 20.25 5 20.25H3.125C2.95924 20.25 2.80027 20.171 2.68306 20.0303C2.56585 19.8897 2.5 19.6989 2.5 19.5V17.25H5.625Z'
                fill='#827CA8'
            />
            <path
                opacity='0.2'
                d='M17.5 11.25L15.1641 4.95C15.1156 4.81672 15.0359 4.70322 14.9346 4.62333C14.8334 4.54343 14.7149 4.50058 14.5938 4.5H5.40625C5.28507 4.50058 5.16664 4.54343 5.06538 4.62333C4.96413 4.70322 4.88441 4.81672 4.83594 4.95L2.5 11.25H17.5Z'
                fill='#827CA8'
            />
            <path
                d='M1.25 11.25H18.75'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M17.5 17.25V19.5C17.5 19.6989 17.4342 19.8897 17.3169 20.0303C17.1997 20.171 17.0408 20.25 16.875 20.25H15C14.8342 20.25 14.6753 20.171 14.5581 20.0303C14.4408 19.8897 14.375 19.6989 14.375 19.5V17.25'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5.625 17.25V19.5C5.625 19.6989 5.55915 19.8897 5.44194 20.0303C5.32473 20.171 5.16576 20.25 5 20.25H3.125C2.95924 20.25 2.80027 20.171 2.68306 20.0303C2.56585 19.8897 2.5 19.6989 2.5 19.5V17.25'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M5 14.25H6.25'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M13.75 14.25H15'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
            <path
                d='M17.5 11.25L15.1641 4.95C15.1156 4.81672 15.0359 4.70322 14.9346 4.62333C14.8334 4.54343 14.7149 4.50058 14.5938 4.5H5.40625C5.28507 4.50058 5.16664 4.54343 5.06538 4.62333C4.96413 4.70322 4.88441 4.81672 4.83594 4.95L2.5 11.25V17.25H17.5V11.25Z'
                stroke='#827CA8'
                strokeWidth='1.25'
                strokeLinecap='round'
                strokeLinejoin='round'
            />
        </svg>
    );
};

export default CarIcon;
